export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-extrabold text-white tracking-wide">
              刃牙漫画
            </span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed max-w-xs">
              刃牙漫画免费全集在线阅读平台。收录刃牙系列全部篇章，下拉式即时阅读，无需充值，畅享热血格斗漫画的魅力。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">热门排行</a></li>
              <li><a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">更新动态</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">更多合作伙伴即将加入</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系与声明</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              本站为刃牙漫画爱好者交流平台，所有漫画内容仅供爱好者学习交流。如有任何版权问题，请通过联系我们页面与我们沟通。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-200"></i>
              </a>
              <div className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-200"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-200"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 刃牙漫画 - 刃牙漫画免费全集在线阅读。保留所有权利。
          </p>
          <p className="text-xs text-background-500">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-accent-400 transition-colors cursor-pointer">返回顶部</a>
          </p>
        </div>
      </div>
    </footer>
  );
}